<div class="w-full md:w-96 border border-gray-200 dark:border-gray-700 rounded-lg p-4 flex flex-col gap-3">
    <div class="flex items-center gap-3">
        <img class="w-8 h-auto" [src]="logoUrl()" alt="" />
        <span class="font-semibold truncate">{{ link().integration?.identifier }}</span>
        @if (saving()) {
            <i class="fas fa-spinner animate-spin text-primary ms-auto"></i>
        }
    </div>

    @if (!productGroupId()) {
        <p class="text-sm text-gray-500">
            {{ 'product-group.save-to-map-integrations' | translate }}
        </p>
    } @else if (!categoriesSupported()) {
        <p class="text-sm text-gray-500">
            {{ 'product-group.shop-categories-not-supported' | translate }}
        </p>
    } @else {
        @if (categoriesLoadFailed()) {
            <p class="text-sm text-red-500">
                {{ 'product-group.shop-categories-load-failed' | translate }}
            </p>
        }
        <div class="flex items-start gap-2">
            <p-checkbox
                [binary]="true"
                [ngModel]="!!link().lockShopCategory"
                (ngModelChange)="onLockShopCategoryChange($event)"
                [disabled]="saving()"
                [inputId]="'product-group-lock-shop-category-' + link().integrationId"
            />
            <div class="flex flex-col gap-0.5">
                <label
                    class="text-sm font-medium"
                    [attr.for]="'product-group-lock-shop-category-' + link().integrationId"
                >
                    {{ 'product-group.lock-shop-category' | translate }}
                </label>
                <span class="text-xs text-gray-400">{{
                    'product-group.lock-shop-category-hint' | translate
                }}</span>
            </div>
        </div>
        <div class="flex flex-col gap-1">
            <label class="text-sm font-medium">{{ 'product-group.shop-category' | translate }}</label>
            <phx-select
                [items]="categoryOptions()"
                optionLabel="label"
                optionValue="id"
                [value]="link().externalEntityId"
                [loading]="loadingCategories()"
                [disabled]="saving() || !link().lockShopCategory"
                [showClear]="true"
                [searchable]="true"
                (onFilter)="onCategoryFilter($event)"
                (onShow)="onCategoryFilter('')"
                (onModelChange)="onShopCategoryChange($event)"
                [dataTestId]="'product-group-shop-category-' + link().integrationId"
            />
            @if (!link().lockShopCategory && !link().externalEntityId) {
                <span class="text-xs text-gray-400">{{ shopCategoryCreatedOnSyncHint | translate }}</span>
            }
        </div>
    }
</div>
